import { gql } from '@apollo/client';

export const siteSettings = gql`
    query ($type: String) {
      siteSettings(type: $type) {
        name
        value
      }
    }
    `;

export const adminUserLogout = gql`
    query {
        adminUserLogout {
            status
        }
      }
    `;

export const getSideMenu = gql`
    query {
      getSideMenu {
            title
            description
            name
            page
            step
            isEnable
      }
    }
    `;

export const getAllPaymentMethods = gql`
    query getAllPaymentMethods {
        getAllPaymentMethods {
            results{
                id
                name
                paymentName
                processedIn
                fees
                currency
                details
                isEnable
                paymentType
                createdAt
                updatedAt
            }
            errorMessage
            status
        }
    }
    `;

export const updatePaymentGateWayStatus = gql`
    mutation updatePaymentGateWayStatus ($id: Int!, $isEnable: Boolean!) {
        updatePaymentGatewayStatus(id: $id, isEnable: $isEnable) {
            status
            errorMessage
        }
    }
    `;

export const updateSearchSettings = `query(
    $id: Int,
    $minPrice: Float,
    $maxPrice: Float,
    $priceRangeCurrency: String,
    ){
      updateSearchSettings(
          id: $id,
          minPrice: $minPrice,
          maxPrice: $maxPrice,
          priceRangeCurrency: $priceRangeCurrency,
      ) {
          status
      }
    }`;

export const updateBannerSettings = `query (
      $id: Int,
      $title: String,
      $content: String,
    ) {
      updateBannerSettings (
        id: $id,
        title: $title,
        content: $content,
      ) {
          status
      }
    }`;